var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-0",staticStyle:{"background-color":"white"}},[_c('Header'),_c('banners'),_c('career-jobs'),_c('bottom-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }